import axios from "axios";

import { reservationsApi } from "api/services/reservations";
import { CountryCode } from "custom-types/CountryCode";
import logError from "utils/logError";

export const getDeliveryOrderWindows = async (
  dispensaryId: number,
  domainCountryCode: CountryCode
) => {
  if (!dispensaryId) {
    return [];
  }

  try {
    const { data } = await reservationsApi({ domainCountryCode }).get(
      `/v1/dispensaries/${dispensaryId}/scheduled_order_windows/delivery`
    );

    return data?.days;
  } catch (e) {
    if (axios.isAxiosError(e)) {
      const errorData = e.response?.data as { error: string; status: number };
      if (errorData) {
        logError(errorData.error, {
          functionName: "getDeliveryOrderWindows",
          service: "reservations",
          statusCode: errorData.status,
        });
      } else {
        logError(
          (e.response?.statusText !== "" && e.response?.statusText) ||
            e.message,
          {
            functionName: "getDeliveryOrderWindows",
            service: "reservations",
            statusCode: e.response?.status || e.code || "UNKNOWN",
          }
        );
      }
    } else {
      logError("reservationUnknownError", {
        functionName: "getDeliveryOrderWindows",
        service: "reservations",
      });
    }

    throw e;
  }
};
